import { useCallback } from "react";
import { useSelector } from "react-redux";

import environments from "@/environments";
import { useApi } from "@/hooks/useApi";
import { RootState } from "@/reducers/types";
import { Machine } from "@/sx-layout/components/plotmap/models";

export const useMachineApi = (plotPlanId: number) => {
  const api = useApi();

  const layoutDate = useSelector<RootState, Date>((state) => state.plotmap.layoutDate);

  const fetchMachines = async (): Promise<GetMachinesResponse | undefined> => {
    const dateStr = convertLayoutDate(layoutDate);
    const endpoint = `${environments.API_BASE_URI}/plot_plans/${plotPlanId}/machines?layout_date=${dateStr}`;
    return api.get(endpoint);
  };

  // 更新系の排他リロードをどう実装するかはusePlotPlanMappingを参照
  const convertLayoutDate = useCallback((layout_date: Date) => {
    return `${layout_date.getFullYear()}-${(layout_date.getMonth() + 1).toString().padStart(2, "0")}-${layout_date
      .getDate()
      .toString()
      .padStart(2, "0")}`;
  }, []);

  return { fetchMachines } as const;
};

// APIのresponse/requestの型はhooks(use*Api.ts)の中で定義する
type GetMachinesResponse = { machines: Machine[] };
